/**
 * Normaliza ``detail`` de erros FastAPI/Starlette para uma string de toast.
 *
 * O backend devolve:
 *   - string  (HTTPException)
 *   - lista de ``{ loc, msg, type }`` (validação 422)
 *   - objecto pontual
 * Passar isso em cru ao ``toast.error`` faz o React interpolar campos em
 * falta e aparecer o sufixo literal ``undefined`` a seguir à mensagem.
 */
export function formatApiDetail(detail) {
  if (detail == null || detail === '') return undefined;
  if (typeof detail === 'string') {
    const trimmed = detail.trim();
    return trimmed || undefined;
  }
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (typeof item === 'string') return item.trim();
        if (item && typeof item === 'object') {
          const msg = item.msg || item.message;
          return typeof msg === 'string' ? msg.trim() : '';
        }
        return '';
      })
      .filter(Boolean);
    return parts.length ? parts.join('; ') : undefined;
  }
  if (typeof detail === 'object') {
    const msg = detail.msg || detail.message;
    if (typeof msg === 'string' && msg.trim()) return msg.trim();
  }
  return undefined;
}

export function formatApiError(err, fallback = 'Erro') {
  const data = err?.response?.data;
  const fromDetail = formatApiDetail(data?.detail);
  if (fromDetail) return fromDetail;
  if (typeof data === 'string' && data.trim()) return data.trim();
  return fallback;
}

/** Quando o pedido usa ``responseType: 'blob'``, o 4xx vem como Blob JSON. */
export async function parseBlobErrorData(error) {
  const data = error?.response?.data;
  if (typeof Blob === 'undefined' || !(data instanceof Blob)) return;
  try {
    const text = await data.text();
    const trimmed = (text || '').trim();
    if (!trimmed) return;
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      error.response.data = JSON.parse(trimmed);
    } else {
      error.response.data = { detail: trimmed };
    }
  } catch {
    // mantém o Blob — o caller usa o fallback
  }
}

export function normalizeAxiosErrorDetail(error) {
  const data = error?.response?.data;
  if (!data || typeof data !== 'object') return;
  if (typeof Blob !== 'undefined' && data instanceof Blob) return;
  const normalized = formatApiDetail(data.detail);
  error.response.data = { ...data, detail: normalized };
}
